@if(isBrowser){
    <footer id="footer">
        <div class="container">
            @if(settings_data){
                <div class="footer-warapper">
                    <div class="col-left">
                        <div id="copyright" class="col-left" [innerHTML]="settings_data[2]?.value"></div>
                    </div>
                    <div class="col-right ml-auto">
                        <ul id="credit">
                            <li>
                                <a href="javascript:void(0);" routerLink="/terms-conditions">terms of use</a>
                            </li>
                            <li>
                                <a href="javascript:void(0);" routerLink="/faqs">FAQs</a>
                            </li>
                            <li>
                                <a href="javascript:void(0);" routerLink="/employment">employment</a>
                            </li>
                            <li>
                                @if(!login){
                                    <a href="javascript:void(0);" routerLink="/login">login</a>
                                }
                            </li>
                            <li>
                                <a href="javascript:void(0);" routerLink="/privacy-policy">privacy policy</a>
                            </li>
                            <li>
                                <span class="copyright-text">© {{currentYear}}, Spur Experiences</span>
                            </li>
                        </ul>
                    </div>
                </div>
            }
        </div>
    </footer>
}

<!-- <a id="msgIocnFixed">
    <i class="far fa-envelope"></i>
</a> -->